define('home/collections/ChannelProfileCollection',[
    'underscore',

    'core/collections/PaginatedCollection',
    'core/UniqueModel',

    'home/activityExpander',
    'home/models/ChannelProfile',
], function (
    _,

    PaginatedCollection,
    UniqueModel,

    activityExpander,
    ChannelProfile
) {
    'use strict';

    var CollectionModel = ChannelProfile;
    var ChannelProfileCollection = PaginatedCollection.extend({
        model: UniqueModel.boundModel(CollectionModel),

        parse: function (response) {
            response = PaginatedCollection.prototype.parse.call(this, response);

            // Some endpoints use reference/objects mapping for channels, which are handled
            // differently.
            if (response.items) {
                return _.map(response.items, function (listedChannel) {
                    var channel = activityExpander.buildChannel(response.objects, listedChannel.reference);
                    var attrs = {
                        channel: channel,
                    };
                    attrs[CollectionModel.prototype.idAttribute] = channel.id;

                    return {
                        id: channel.id,
                        channel: channel,
                    };
                });
            }

            return response;
        },
    });

    return ChannelProfileCollection;
});

